import React from 'react';
import { Icon } from '@iconify/react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  width?: string;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children, footer, width = '520px' }) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0, 0, 0, 0.50)',
        backdropFilter: 'blur(4px)',
        WebkitBackdropFilter: 'blur(4px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9000,
        animation: 'fadeIn 0.2s ease',
        padding: '40px 0',
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: 'var(--modal-bg)',
          backdropFilter: 'blur(24px)',
          WebkitBackdropFilter: 'blur(24px)',
          border: '1px solid var(--glass-border)',
          borderRadius: 'var(--radius-xl)',
          maxWidth: width,
          width: '90%',
          maxHeight: '100%',
          boxShadow: 'var(--modal-shadow)',
          animation: 'modalIn 0.25s ease',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between', 
          padding: '24px 32px 20px',
          borderBottom: '1px solid var(--border-base)',
          flexShrink: 0,
        }}>
          <h3 style={{
            fontFamily: 'var(--font-heading)',
            fontSize: '20px',
            fontWeight: 600,
            color: 'var(--text-primary)',
            margin: 0,
          }}>
            {title}
          </h3>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              color: 'var(--text-muted)',
              cursor: 'pointer',
              padding: '4px',
              borderRadius: 'var(--radius-sm)',
              transition: 'color var(--transition-fast)',
            }}
          >
            <Icon icon="solar:close-circle-bold-duotone" width={24} />
          </button>
        </div>

        {/* Scrollable Content */}
        <div style={{ 
          flex: 1,
          overflowY: 'auto',
          padding: '24px 32px',
          color: 'var(--text-secondary)', 
          fontSize: '14px', 
          lineHeight: 1.6,
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
        }}
        className="modal-content-scroll">
          {children}
        </div>

        {/* Footer */}
        {footer && (
          <div style={{ 
            display: 'flex', 
            gap: '10px', 
            justifyContent: 'flex-end', 
            padding: '16px 32px 24px',
            borderTop: '1px solid var(--glass-border)',
            flexShrink: 0,
          }}>
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
